import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import AppLayoutView from '@/components/layouts/AppLayout.vue'
import adminRoutes from './modules/admin';
import CodebookRoutes from './modules/codebook';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect:'/home',//设置路由重定向第一次进入的页面
    component: AppLayoutView,
    children: [
        ...adminRoutes,
        ...CodebookRoutes,
        // 添加其他模块的路由
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/LoginView.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "about" */ '../views/RegisterView.vue')
  },
  {
    path: '/register/success',
    name: 'register_success',
    component: () => import(/* webpackChunkName: "about" */ '../views/RegisterSuccessView.vue')
  },
  {
    path: '/find/password',
    name: 'find_password',
    component: () => import(/* webpackChunkName: "about" */ '../views/FindPasswordView.vue')
  },
  {
    path: '/find/password/success',
    name: 'find_password_success',
    component: () => import(/* webpackChunkName: "about" */ '../views/FindPasswordSuccessView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router